export default __webpack_public_path__ + "static/media/3B069A_1_0.21d0f44b.ttf";